import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { StockModelCardHeaderStyledOV } from './StockModelCardHeaderStyled.OV';
import { rem } from 'polished';

export const StockModelCardHeaderStyledOVGB = styled(StockModelCardHeaderStyledOV)`
    .stockModelCard-header--engineInfo {
        color: ${({ theme }) => theme.colors.grey1};
    }
`;
